import { Stack, Typography } from '@mui/material'

export default function Congress() {
  return (
    <Stack
      spacing={2}
      useFlexGap
      alignItems='center'
      width={{ xs: '100%', sm: '70%' }}>
      <Stack flexDirection='row' gap={2}>
        <Typography
          variant='h1'
          color='primary.main'
          fontSize='clamp(3rem, 10vw, 3.5rem)'
          ml={2}
          sx={theme => ({
            ...theme.applyStyles('dark', { color: 'primary.light' }),
          })}>
          Congress
        </Typography>
      </Stack>
    </Stack>
  )
}
